export default __webpack_public_path__ + "static/media/googleplay-logo.3ad7732c.svg";